import axios from "axios";
import { API } from "@/lib/api";

const KEY = (code) => `boy_token_${code}`;
export const boyToken = {
  get: (code) => localStorage.getItem(KEY(code)),
  set: (code, t) => localStorage.setItem(KEY(code), t),
  clear: (code) => localStorage.removeItem(KEY(code)),
};

export function boyApi(code) {
  const a = axios.create({ baseURL: `${API}/public/boy/${code}` });
  a.interceptors.request.use((cfg) => {
    const t = boyToken.get(code);
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  return a;
}

export const EMPTY_ADDR = { cep: "", street: "", number: "", complement: "", district: "", city: "", state: "" };
export const RIDE_STATUS = { aguardando: "Aguardando", andamento: "Em andamento", entregue: "Entregue", cancelada: "Cancelada" };
export const STATUS_TONE = {
  aguardando: "bg-amber-500/15 text-amber-700 dark:text-amber-300",
  andamento: "bg-sky-500/15 text-sky-700 dark:text-sky-300",
  entregue: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300",
  cancelada: "bg-muted text-muted-foreground",
};
export const PERIOD_LABELS = { semanal: "semanal", quinzenal: "quinzenal", mensal: "mensal" };

export function rideStep(r) {
  if (r.status !== "aguardando") return RIDE_STATUS[r.status];
  if (r.payment?.status !== "pago") return "Aguardando pagamento";
  return r.dispatch?.status === "no_courier" ? "Sem motoboy no momento" : "Procurando motoboy";
}

export const addrMissing = (a, what) => (!a.street.trim() ? `Informe a rua da ${what}` : !a.city.trim() ? `Informe a cidade da ${what}` : a.state.trim().length !== 2 ? `Informe a UF da ${what}` : "");
export const mapsLink = (label) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(label)}`;
export const fmtKm = (v) => Number(v || 0).toLocaleString("pt-BR", { maximumFractionDigits: 1 });
